import { useEffect, useState } from "react";
import { observer } from "mobx-react";
import { ArchivedProjectStore, ArchivedProjectStoreProvider } from "@stores";
import { useStores, useWorkspaceWebsocket } from "@hooks";
import { ArchivedProjectsSocketProvider } from "@client";
import { PageCircularProgress } from "@components";
import { ArchivedProjectsView } from "./ArchivedProjectsView";
import { getWorkTypesQuery } from "@query";

export const ArchivedProjects = observer(() => {
  const { userStore } = useStores();
  const socket = useWorkspaceWebsocket();
  
  const [ archivedProjectStore ] = useState(new ArchivedProjectStore());

  useEffect(() => {
    load();
  });
  
  const load = async () => {
    const workTypes = await getWorkTypesQuery();
    archivedProjectStore.setWorkTypes(workTypes);
  }
  
  return !userStore.workspaceUuid || !socket?.socketInitialized
    ? (
      <PageCircularProgress />
    ) : (
      <ArchivedProjectStoreProvider value={archivedProjectStore}>
        <ArchivedProjectsSocketProvider>
          <ArchivedProjectsView />
        </ArchivedProjectsSocketProvider>
      </ArchivedProjectStoreProvider>
    );
});
